/**
 * An Airbrake `Filter` that logs notices to the console. It
 * does not change the notice, nor does it block it.
 * @param notice INotice
 */
const loggingFilter = (notice) => {
    // eslint-disable-next-line no-console
    console.log('[Airbrake Logging Filter] - notice: ', notice);
    return notice;
};
export default loggingFilter;



// WEBPACK FOOTER //
// ./node_modules/@doxo/willow-airbrake/dist/esm/filters/logging-filter.js